import React from 'react';

import { useTranslation } from 'react-i18next';

import { CoinRaceLeaderboardType } from '@types';

import * as Styled from './top-winner-card.styled';

type OwnProps = {
	winner?: CoinRaceLeaderboardType | null;
	place: number;
	isMe?: boolean;
};

const TopWinnerCard: React.FC<OwnProps> = ({ winner, place, isMe }) => {
	const { t } = useTranslation('coin_race_details');

	const score = winner?.score;
	const rewardValue = winner?.reward_value;
	const hasPrize = Boolean(rewardValue) && String(rewardValue) !== '0';

	return (
		<Styled.Wrapper $place={place}>
			<Styled.AvatarContainer>
				<Styled.Avatar $place={place} $isMe={isMe} />
			</Styled.AvatarContainer>

			<Styled.Username $isMe={isMe}>{winner?.user_pm_id ?? ''}</Styled.Username>

			<Styled.CardBox $place={place}>
				<Styled.StarIcon $place={place} />

				<Styled.InfoContainer>
					<Styled.PrizeContainer>
						<Styled.PrizeLabel>{hasPrize ? t('prize') : ''}</Styled.PrizeLabel>
						<Styled.PrizeValue>{hasPrize ? rewardValue : ''}</Styled.PrizeValue>
					</Styled.PrizeContainer>

					<Styled.FooterRow>
						<Styled.FooterItem>
							<Styled.FooterLabel>{t('place')}</Styled.FooterLabel>
							<Styled.FooterValue>{place ?? '-'}</Styled.FooterValue>
						</Styled.FooterItem>

						<Styled.Divider />

						<Styled.FooterItem>
							<Styled.FooterLabel>{t('points')}</Styled.FooterLabel>
							<Styled.FooterValue>{score ?? 0}</Styled.FooterValue>
						</Styled.FooterItem>
					</Styled.FooterRow>
				</Styled.InfoContainer>
			</Styled.CardBox>
		</Styled.Wrapper>
	);
};

export default TopWinnerCard;
